export default "__VITE_ASSET__kr4GZMri__"